var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "generate-lead",
    clipPath: "url(#clip0_229_1976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6117 15.25L21.7077 19.379C21.8915 19.5649 21.9943 19.8159 21.9935 20.0773C21.9928 20.3388 21.8885 20.5892 21.7037 20.774L21.7007 20.777C21.5168 20.9592 21.2682 21.0609 21.0094 21.0598C20.7506 21.0586 20.5029 20.9548 20.3207 20.771L16.2227 16.639L17.6117 15.249V15.25Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9286 15.6372C14.4418 18.124 10.4098 18.124 7.92293 15.6372C5.43607 13.1503 5.43607 9.11832 7.92293 6.63146C10.4098 4.1446 14.4418 4.1446 16.9286 6.63146C19.4155 9.11832 19.4155 13.1503 16.9286 15.6372Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1215 9.55898C12.8897 9.55898 13.5125 8.93621 13.5125 8.16798C13.5125 7.39975 12.8897 6.77698 12.1215 6.77698C11.3532 6.77698 10.7305 7.39975 10.7305 8.16798C10.7305 8.93621 11.3532 9.55898 12.1215 9.55898Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0559 14.482C16.0559 13.4862 15.6603 12.5313 14.9562 11.8271C14.2521 11.123 13.2971 10.7275 12.3014 10.7275C11.3056 10.7275 10.3506 11.123 9.64654 11.8271C8.94244 12.5313 8.54688 13.4862 8.54688 14.482H16.0559Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.64616 6.16298C5.32878 6.16298 5.88216 5.6096 5.88216 4.92698C5.88216 4.24436 5.32878 3.69098 4.64616 3.69098C3.96353 3.69098 3.41016 4.24436 3.41016 4.92698C3.41016 5.6096 3.96353 6.16298 4.64616 6.16298Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.42875 7.62397C5.92079 7.34122 5.34777 7.19608 4.76645 7.20293C4.18514 7.20978 3.6157 7.36837 3.11453 7.66301C2.61337 7.95764 2.19788 8.37809 1.9092 8.88272C1.62053 9.38734 1.4687 9.95862 1.46875 10.54H5.75775",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.0101 6.16298C19.3275 6.16298 18.7741 5.6096 18.7741 4.92698C18.7741 4.24436 19.3275 3.69098 20.0101 3.69098C20.6927 3.69098 21.2461 4.24436 21.2461 4.92698C21.2461 5.6096 20.6927 6.16298 20.0101 6.16298Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.2275 7.62397C18.7355 7.34122 19.3085 7.19608 19.8898 7.20293C20.4711 7.20978 21.0406 7.36837 21.5417 7.66301C22.0429 7.95764 22.4584 8.37809 22.747 8.88272C23.0357 9.38734 23.1875 9.95862 23.1875 10.54H18.8985",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_1976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.828125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLms);
export default __webpack_public_path__ + "static/media/LMS.f230b646a8b0987b3a6869d036674dc1.svg";
export { ForwardRef as ReactComponent };